import {ZoomIn} from "@mui/icons-material";
import {AdminIconBarItem} from "../icon-bar/AdminIconBarItem";
import React from "react";
import {useScrollytellTranslation} from "../Admin/scrollytellContext";

export const MapZoomInButton = ({zoom, templateId, onUpdate}) => {
    const t = useScrollytellTranslation()
    const handleUpdate = () => {
        onUpdate(
            "zoom",
            zoom ? zoom + 1 : 8
        )
    }

    if(7 === templateId) {
        return (
            <AdminIconBarItem
                Icon={ZoomIn}
                disabled={zoom >= 10}
                onClick={handleUpdate}
                tooltip={t(
                    "editSectionPanel.mapZoomIn",
                    "Zoom inn"
                )}
                tooltipPosition="top"
            />
        )
    } else {
        return null
    }
}